import React, { useMemo } from 'react'
import { Button, Form, Spinner, Row, Col } from 'react-bootstrap'
import { Formik } from 'formik'

const OnBoardingSurvey = ({ onContinue, status }) => {
  const capitalizeFirstLetter = (str) => {
    if (!str) return str
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  }

  const hearAboutUsOptions = useMemo(() => {
    const options = [
      'Google (or equivalent)',
      'YouTube',
      'Referred by friend/colleague',
      'AI Chatbot (e.g. ChatGPT)',
      'Reddit',
      'A Tiiny Host link',
      'Social Media (e.g LinkedIn)',
      'Other'
    ]

    const shuffled = [...options]
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
    }

    return shuffled
  }, [])

  return (
    <Formik
      onSubmit={onContinue}
      initialValues={{
        firstName: '',
        lastName: '',
        hearAboutUs: ''
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => (
        <Form onSubmit={handleSubmit}>
          <h3 className="mb-2 color-purple">Let's improve your experience</h3>
          <p>Please tell us a little more information.</p>

          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="bold">First Name</Form.Label>
                <Form.Control
                  name="firstName"
                  type="text"
                  value={values.firstName}
                  onChange={(e) => {
                    const capitalizedValue = capitalizeFirstLetter(e.target.value)
                    setFieldValue('firstName', capitalizedValue)
                  }}
                  placeholder="Enter your first name"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="bold">Last Name</Form.Label>
                <Form.Control
                  name="lastName"
                  type="text"
                  value={values.lastName}
                  onChange={(e) => {
                    const capitalizedValue = capitalizeFirstLetter(e.target.value)
                    setFieldValue('lastName', capitalizedValue)
                  }}
                  placeholder="Enter your last name"
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mt-3">
            <Form.Label className="bold">How did you hear about us?</Form.Label>
            <Form.Control
              name="hearAboutUs"
              as="select"
              value={values.hearAboutUs}
              onChange={(e) => setFieldValue('hearAboutUs', e.target.value)}
            >
              <option value="">Select...</option>
              {hearAboutUsOptions.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Button
            type="submit"
            disabled={status.loading}
            className="mt-3 float-right tr-onboarding-questionnaire-submit"
            data-testid="OnBoardingSurvey-submit-button"
          >
            {status.loading ? <Spinner animation="border" size="sm" /> : 'Complete'}
          </Button>
        </Form>
      )}
    </Formik>
  )
}

export default OnBoardingSurvey
